import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./banner.scss";
import axios from "axios";
import { API_URL } from "../../../utils/Environment";
import Loader from "../../../hooks/Loader";

const Banner = () => {

  const [loader, setLoader] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [type, setType] = useState("all");
  const [dashboardData, setDashboardData] = useState(null);

  // Fetch dashboard data
  const fetchDashboardData = async (
    filterType = type,
    start = startDate,
    end = endDate
  ) => {
    try {
      setLoader(true);
      const token = localStorage.getItem("token");
      let params = {};

      if (filterType === "custom") {
        if (!start || !end) {
          console.warn("⚠️ Please select both start and end dates before fetching.");
          return;
        }
        if (end < start) {
          console.warn("⚠️ End date must be greater than or equal to start date.");
          return;
        }

        // ✅ Only send dates
        params.startDate = start.toISOString();
        params.endDate = end.toISOString();
      } else if (filterType === "all") {
        // ✅ All filter → send only fixed dates
        params.startDate = "2024-08-31T19:00:00.000Z";
        params.endDate = "2028-09-05T21:13:20.736Z";
      } else {
        // ✅ Day / Week / Month → only send type
        params.type = filterType;
      }

      const response = await axios.get(`${API_URL}dashboard/data`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setDashboardData(response.data.data);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      console.error("Error fetching dashboard data:", err);
    }
  };

  // formatNumber
  const formatNumber = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "0";

    const absValue = Math.abs(value);

    if (absValue >= 1.0e12) {
      return (value / 1.0e12).toFixed(2).replace(/\.00$/, "") + "T";
    } else if (absValue >= 1.0e9) {
      return (value / 1.0e9).toFixed(2).replace(/\.00$/, "") + "B";
    } else if (absValue >= 1.0e6) {
      return (value / 1.0e6).toFixed(2).replace(/\.00$/, "") + "M";
    } else if (absValue >= 1.0e3) {
      return (value / 1.0e3).toFixed(2).replace(/\.00$/, "") + "K";
    } else {
      return value.toFixed(2).replace(/\.00$/, "");
    }
  };


  useEffect(() => {
    if (type === "custom") {
      if (startDate && endDate) {
        fetchDashboardData("custom", startDate, endDate); // ✅ only runs when both exist
      }
    } else if (type == 'one day' || type == 'one week' || type == 'one month' || type == 'all') {
      fetchDashboardData(type);
    }
  }, [type, startDate, endDate]);

  return (
    <>
      {loader && <Loader />}
      <section className="main_banner" id="home">
        <img src="\assets\dashbg.png" className="img_shade" alt="" />
        <div className="custom-container">
          <div className="inner_banner">
            <div className="anotther_banner">
              <h4>Dashboard</h4>
              <div className="rihght_side">
                {/* Filters */}
                <h3 className={`${type}` == 'one day' ? "active" : ""} onClick={() => setType("one day")}>D</h3>
                <h3 className={`${type}` == 'one week' ? "active" : ""} onClick={() => setType("one week")}>W</h3>
                <h3 className={`${type}` == 'one month' ? "active" : ""} onClick={() => setType("one month")}>M</h3>
                <h3 className={`${type}` == 'all' ? "active" : ""} onClick={() => setType("all")}>ALL</h3>

                {/* Calendar with SVG (your original design) */}
                <div className="calendar_wrapper" style={{ position: "relative" }}>
                  <div
                    className="calendar_svg"
                    onClick={() => setShowCalendar(!showCalendar)}
                    style={{ cursor: "pointer" }}
                  >
                    {/* ✅ Keeping your SVG */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M7.7168 2.08319H8.59649V6.7535H7.7168V2.08319Z" fill="#6E8491" />
                      <path d="M15.2969 2.08319H16.1766V6.7535H15.2969V2.08319Z" fill="#6E8491" />
                      <path d="M20.0344 6.31353C20.0344 5.9276 19.8807 5.55752 19.6078 5.28463C19.335 5.01175 18.9648 4.85806 18.5789 4.85806H5.31331C4.92738 4.85806 4.55729 5.01173 4.2844 5.28463C4.01151 5.55752 3.85784 5.9276 3.85784 6.31353V19.5792C3.85784 19.9651 4.01153 20.3352 4.2844 20.6081C4.55729 20.881 4.92738 21.0346 5.31331 21.0346H13.3336V21.9143H5.31331C4.69399 21.9143 4.09967 21.6686 3.66174 21.2307C3.22384 20.7928 2.97815 20.1985 2.97815 19.5792V6.31353C2.97815 5.69421 3.22382 5.09989 3.66174 4.66197C4.09967 4.22404 4.69399 3.97838 5.31331 3.97838H18.5789C19.1982 3.97838 19.7926 4.22406 20.2305 4.66197C20.6684 5.09989 20.9141 5.69421 20.9141 6.31353V14.3338H20.0344V6.31353Z" fill="#6E8491" />
                      <path d="M18.4429 9.6633V10.543H5.4499V9.6633H18.4429Z" fill="#6E8491" />
                      <path d="M22.0446 17.6833L17.6321 22.0958L15.1149 19.5786L15.7368 18.9559L16.0477 19.2676L17.6313 20.8512L21.4219 17.0614L22.0446 17.6833Z" fill="#6E8491" />
                    </svg>
                  </div>

                  {showCalendar && (
                    <div style={{ position: "absolute", top: "30px", left: "-219px", zIndex: 99999 }}>
                      <DatePicker
                        selectsRange
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(dates) => {
                          const [start, end] = dates;
                          setStartDate(start);
                          setEndDate(end);
                          setType("custom"); // mark filter as custom
                        }}
                        maxDate={new Date()} // ✅ disable future dates
                        inline
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ✅ Keeping your card layout + % spans */}
            <div className="cards_parents">
              <div className="cardss">
                <img src="\assets\one.svg" alt="" />
                <p>New users</p>
                <h3>{(dashboardData?.totalUsers?.count)?.toLocaleString() ?? 0}
                  {type !== "all" && (
                    dashboardData?.totalUsers?.percentageDifference > 0 ?
                      <span className="greenspan">+{dashboardData?.totalUsers?.percentageDifference}%</span>
                      :
                      <span className="redspan">{dashboardData?.totalUsers?.percentageDifference ? dashboardData?.totalUsers?.percentageDifference : 0}%</span>
                  )
                  }
                </h3>
              </div>
              <div className="cardss">
                <img src="\assets\two.svg" alt="" />
                <p>$TOMI burned</p>
                <div className="d-flex flex-column flex-md-row justify-content-between">
                  <h3>
                    {(dashboardData?.totalMintAndBurns?.totalBurnt)?.toLocaleString() ?? 0} TOMI
                    {/* <span className="redspan">-5%</span> */}
                  </h3>
                  <div className="d-flex flex-column justify-content-between">
                    <p className="p-0 text-right">
                      &nbsp; ~${dashboardData?.totalMintAndBurns?.totalBurntUsdt
                        ? formatNumber(Number(dashboardData.totalMintAndBurns.totalBurntUsdt.toFixed(2)))
                        : 0}
                    </p>
                    {
                      type !== "all" && (
                        dashboardData?.totalMintAndBurns?.percentageDifferenceBurnt > 0 ?
                          <span className="greenspan text-right">+{dashboardData?.totalMintAndBurns?.percentageDifferenceBurnt}%</span>
                          :
                          <span className="redspan text-right">{dashboardData?.totalMintAndBurns?.percentageDifferenceBurnt ? dashboardData?.totalMintAndBurns?.percentageDifferenceBurnt : 0}%</span>
                      )
                    }
                  </div>
                </div>
              </div>
              <div className="cardss">
                <img src="\assets\three.svg" alt="" />
                <p>1-1 messages</p>
                <h3>{(dashboardData?.totalChatMessages?.count)?.toLocaleString() ?? 0}
                  {
                    type !== "all" && (
                      dashboardData?.totalChatMessages?.percentageDifference > 0 ?
                        <span className="greenspan">+{dashboardData?.totalChatMessages?.percentageDifference}%</span>
                        :
                        <span className="redspan">{dashboardData?.totalChatMessages?.percentageDifference ? dashboardData?.totalChatMessages?.percentageDifference : 0}%</span>
                    )
                  }
                </h3>
              </div>
              <div className="cardss">
                <img src="\assets\four.svg" alt="" />
                <p>Group messages</p>
                <h3>{(dashboardData?.totalGroupMessages?.count)?.toLocaleString() ?? 0}
                  {
                    type !== "all" && (
                      dashboardData?.totalGroupMessages?.percentageDifference > 0 ?
                        <span className="greenspan">+{dashboardData?.totalGroupMessages?.percentageDifference}%</span>
                        :
                        <span className="redspan">{dashboardData?.totalGroupMessages?.percentageDifference ? dashboardData?.totalGroupMessages?.percentageDifference : 0}%</span>
                    )
                  }
                </h3>
              </div>
              <div className="cardss">
                <img src="\assets\five.svg" alt="" />
                <p>New groups</p>
                <h3>{(dashboardData?.totalGroups?.count)?.toLocaleString() ?? 0}
                  {
                    type !== "all" && (
                      dashboardData?.totalGroups?.percentageDifference > 0 ?
                        <span className="greenspan">+{dashboardData?.totalGroups?.percentageDifference}%</span>
                        :
                        <span className="redspan">{dashboardData?.totalGroups?.percentageDifference ? dashboardData?.totalGroups?.percentageDifference : 0}%</span>
                    )
                  }
                </h3>
              </div>
              <div className="cardss">
                <img src="\assets\sic.svg" alt="" />
                <p>New chats</p>
                <h3>{(dashboardData?.totalChats?.count)?.toLocaleString() ?? 0}
                  {
                    type !== "all" && (
                      dashboardData?.totalChats?.percentageDifference > 0 ?
                        <span className="greenspan">+{dashboardData?.totalChats?.percentageDifference}%</span>
                        :
                        <span className="redspan">{dashboardData?.totalChats?.percentageDifference ? dashboardData?.totalChats?.percentageDifference : 0}%</span>
                    )
                  }
                </h3>
              </div>
              <div className="cardss">
                <img src="\assets\seven.svg" alt="" />
                <p>New Channels</p>
                <h3>{(dashboardData?.totalChannels?.count)?.toLocaleString() ?? 0}
                  {
                    type !== "all" && (
                      dashboardData?.totalChannels?.percentageDifference > 0 ?
                        <span className="greenspan">+{dashboardData?.totalChannels?.percentageDifference}%</span>
                        :
                        <span className="redspan">{dashboardData?.totalChannels?.percentageDifference ? dashboardData?.totalChannels?.percentageDifference : 0}%</span>
                    )
                  }
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  );
};

export default Banner;